<template>
  <div id="content" class="myAccount">
    <ConfirmModal :dialogVisible='showConfirmDialog' @close="closeConfirmDialog()" @confirmed="confirmDelete($event)" message="Are you sure ? This action can't be canceled." ></ConfirmModal>
    <addLicence :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="setNewLicence($event)" :minLicence="minLicence" :currentLicence="currentLicence" formName="Please enter the new number of licences" ></addLicence>
    <TransfertAccount :dialogVisible='dialogTransfert' :userManaged="account_managed" @close="closeTransfert()" @newValueIsProposed="transfertOwnerShip($event)" formName="Transfert an account" ></TransfertAccount>



    <div class="container">
      <div class="myAccountContent">
        <div class="row">
          <h1 class="title">Manage admin users account</h1>


          <table class="table mt20" v-if="users.length > 0">
            <thead>
              <tr>
                <th>Username</th>
                <th>Email</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Role</th>
                <th>Active</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr   v-for="(subu, u) in users" :key="u">
                <td>{{subu.username}}</td>
                <td>{{subu.email}}</td>
                <td>{{subu.firstname}} {{subu.lastname}}</td>
                <td>{{subu.phone}}</td>
                <td>{{subu.role}} {{subu.rights}}</td>
                <td>
                  <v-badge v-if="subu.isValid" color="info" content="Yes" inline></v-badge>
                  <v-badge v-else color="warning" content="No" inline></v-badge>
                </td>

                <td>

                  <button v-if="subu.role != 'Responsable'" class="btn btn-danger mlrtb10" type="button" @click="deleteAccount(subu._id.$oid)" name="button">Remove</button></td>
              </tr>
            </tbody>

          </table>


        <!-- <table class="table mt20" v-if="users.length > 0">
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>Name</th>
              <th>Role</th>
              <th>Active</th>
              <th>Licence(s)</th>
              <th>Responsable</th>
              <th>#</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, u) in users" :key="u">
              <td>{{user.username}}</td>
              <td>{{user.email}}</td>
              <td>{{user.firstname}} {{user.lastname}}</td>
              <td>{{user.role}} {{user.rights}}</td>
              <td>
                <v-badge v-if="user.isValid" color="info" content="Yes" inline></v-badge>
                <v-badge v-else color="warning" content="No" inline></v-badge>
              </td>
              <td>
                <span v-if="user.role == 'Responsable'">
                  <span v-if="user.account_managed">{{user.account_managed.length + 1}} / {{user.licence}}</span>
                  <span v-else>1 / {{user.licence}}</span>
                </span>
                <span v-else>N.C.</span>

              </td>
              <td>
                <span v-if="user.responsable">{{user.responsable.firstname}} {{user.responsable.lastname}}</span>
              </td>
              <td>
                <button v-if="user.role == 'Responsable'" @click="openTransfert(user)" class="btn btn-primary mlrtb10" type="button" name="button">Transfert ownership</button>

                <button v-if="user.role == 'Responsable'" @click="openModal(user)" class="btn btn-primary mlrtb10" type="button" name="button">Licences allocation</button>
                <button v-if="user.role != 'Responsable'" class="btn btn-danger mlrtb10" type="button" @click="deleteAccount(user._id.$oid)" name="button">Remove</button></td>
            </tr>
          </tbody>

        </table> -->


      </div>
    </div>
          </div>
</div>
</template>
<script>
 // import AddCommentModal from '@/components/modals/addComment.vue'
 // import NewValueModal from '@/components/modals/addValue.vue'
   // import AddSomeThingLink from '@/components/AddSomeThingLink.vue'
// import BookACall from '@/components/bookacall.vue'
 import { toast } from 'vue-sonner'
 import api from '@/tools/api';
  import addLicence from '@/components/modals/addLicence.vue'
// //import StartupInfoLine from '@/components/InfoStartupLine.vue'
// import _ from 'lodash';
 import ConfirmModal from '@/components/modals/ConfirmModal.vue'
  import TransfertAccount from '@/components/modals/transfertAccount.vue'
export default {
  components: {
    ConfirmModal,
    addLicence,
    TransfertAccount
    // AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      seeAllStep: true,
      dialog:false,
      dialogTransfert:false,
      transfertFrom : null,
      account_managed: [],
      minLicence: 0,
      pageInfo: {
        mainTitle : "Manager users",
        subTitle : "Manage users of the platform",
      },
      users: [],
      showConfirmDialog: false,
      asked_for_delete: null,
      candidateForLicence : null,
    }
  },
  methods:{
    openTransfert(user){
      this.account_managed = user.account_managed;
      this.transfertFrom = user._id;
      this.dialogTransfert = true;
    },
    closeTransfert(){
      this.dialogTransfert = false;
      this.account_managed = [];
      this.transfertFrom = null;
    },
    transfertOwnerShip(v){
      console.log(v);
      if(v){
        var pos = {
          newowner : v.newowner,
          oldowner : this.transfertFrom,
        }
        api.post(process.env.VUE_APP_API_URL+"/restrict/transfertOwnerShip",pos,{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          api.get(process.env.VUE_APP_API_URL+"/restrict/all_users").then( (r) => {
            this.users = r.data;
            console.log(r);
          }).catch( (e) => console.log(e));
        toast.success("Account ownership successfully tranfered !");
        this.dialogTransfert = false;
        });
      }
    },
    gobackrouter : function(){
      this.$router.go(-1);
    },
    deleteAccount(v){
      this.showConfirmDialog = true;
      this.asked_for_delete = v;
    },
    closeConfirmDialog(){
      this.showConfirmDialog = false;
      this.asked_for_delete = null;
    },
    openModal(candidate){
      this.candidateForLicence = candidate;
      this.currentLicence = candidate.licence;
      this.minLicence = (candidate.account_managed) ? candidate.account_managed.length + 1 : 0;
      this.dialog = true;
    },
    closeModal(){
      this.candidateForLicence = null;

      this.dialog = false;
    },
    setNewLicence(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/uplicence",
        {
          licence : parseInt(v),
          user : this.candidateForLicence,
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        toast.success("Number of licence updated");
        this.dialog = false;
        api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_experts").then( (r) => {
          this.users = r.data;
          console.log("all_useres",r);
        }).catch( (e) => console.log(e));

      }).catch( () => {
          this.candidateForLicence = null;
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
      }
    },
    confirmDelete(v){
      console.log(v);
      console.log(this.asked_for_delete);
      this.showConfirmDialog = false;
      api.post(process.env.VUE_APP_API_URL+"/restrict/removeaccount",
          {
              toremoved: this.asked_for_delete,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
            toast.success("User successfully delete from your account.")
            api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_experts").then( (r) => {
              this.users = r.data;
              console.log(r);
                  console.log("all_useres",r);
            }).catch( (e) => console.log(e));

        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        this.asked_for_delete = null;
    },
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
     api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_experts").then( (r) => {
       this.users = r.data;
       console.log("data",r);
           console.log("all_useres",r);
     }).catch( (e) => console.log(e));
   },
 watch: {

 }
 // watch(search, (newValue, oldValue) => {
 //   console.log(oldValue);
 //   console.log(newValue);
 //   // fires on nested property mutations
 //   // Note: `newValue` will be equal to `oldValue` here
 //   // because they both point to the same object!
 // },{deep: true})
}
</script>
<style scoped >
.myAccount{
  padding-top:50px;
  padding-bottom: 50px;
}
.myAccountContent{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
padding: 50px;
margin-bottom: 50px;

}
.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
text-align:center;
}
.mt50{
  margin-top:50px;
}

.mlrtb10{
  margin:10px;
}


.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    display:inline-block;
    margin:auto;
    width:auto;
}

.myAccountContent{
  position:relative;
  padding-top:80px;
}
.mt20{
  margin-top:20px;
}
.mb20{
  margin-bottom: 20px;
}

.disconnect{
  position: absolute;
top: 10px;
right: 10px;
padding: 5px 20px;
color: #3783C5;
border: none;
border-bottom: 1px solid #3783C5;
border-radius: 0;
font-size: 16px;
font-weight: bold;
text-decoration: none;
}

.infoVersion{
  position: absolute;
  bottom: 5px;
  right: 15px;
  font-size: 10px;
}

.v-window{
  border: 1px solid #3783C5;
  margin-bottom:50px;
}
.v-tabs{
      background: #115AA4 !important;

}
.v-tab--selected{
  background: #3783C5 !important;
}
.v-tab__slider{
  display:none;
}

.btn-primary{
    background: #3783C5 !important;
}

.label_user .info_name{
font-size: 12px;
line-height: 15px;
color: #B38D2F;
text-transform: uppercase;
font-weight: 500;
}
.label_user  .info_value{
    font-size:16px;
    line-height: 22px;

}
</style>
